import { render, staticRenderFns } from "./BicarbonateDeficiency.vue?vue&type=template&id=256b1d0e&scoped=true&"
import script from "./BicarbonateDeficiency.vue?vue&type=script&lang=js&"
export * from "./BicarbonateDeficiency.vue?vue&type=script&lang=js&"
import style0 from "./BicarbonateDeficiency.vue?vue&type=style&index=0&id=256b1d0e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "256b1d0e",
  null
  
)

export default component.exports